import React from 'react';
import PropTypes from 'prop-types';

import Button from '@mlb/react-patterns/components/Button/button.tsx';

import { Tracking } from 'bdvp-tracking';

const VolumeButton = (props) => {

    let {
        mediaPlayer,
        volume,
        lastVolume,
        muted,
    } = props;

    const isMuted = volume <= 0 ? true : muted;
    const ariaLabel = isMuted ? 'Un-mute' : 'Mute';
    const iconName = isMuted ? 'volume-muted' : 'volume-control';

    return (
        <Button
            size={'md'}
            styleName={'default'}
            shape={'hollow-borderless'}
            hasHover={false}
            iconSize={20}
            ariaLabel={ariaLabel}
            iconName={iconName}
            handlers={{
                onClick: () => {

                    Tracking.trackReelCreationEventButtonClick(ariaLabel);

                    if (isMuted) {

                        mediaPlayer.unMute();
                        const newVolume = lastVolume <= 0.1 ? 0.7 : lastVolume;
                        mediaPlayer.setVolume(newVolume);

                    } else {

                        mediaPlayer.mute();

                    }
                
                },
            }}
        />
    );

};

VolumeButton.propTypes = {
    volume: PropTypes.number.isRequired,
    muted: PropTypes.bool.isRequired,
    lastVolume: PropTypes.number.isRequired,
    mediaPlayer: PropTypes.object,
};

VolumeButton.defaultProps = {
    mediaPlayer: {},
};

export default VolumeButton;
